import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;

export const DialogContent = React.forwardRef(({
  className, children, hideClose = false, side = false, ...props
}, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay className={side
      ? 'fixed inset-0 z-[1300] bg-slate-950/15 transition-opacity duration-200'
      : 'fixed inset-0 z-[1300] bg-slate-950/50 backdrop-blur-sm transition-opacity duration-200'} />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        'tyre-management-v2 fixed left-1/2 top-1/2 z-[1301] flex min-h-0 min-w-0 max-h-[90vh] w-[calc(100%-2rem)] max-w-xl -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-2xl border border-solid border-slate-300 bg-white text-slate-950 shadow-2xl focus:outline-none',
        className,
      )}
      {...props}
    >
      {children}
      {!hideClose && (
        <DialogPrimitive.Close className="tm-button absolute right-4 top-4 z-20 inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200/80 bg-white/90 text-slate-400 shadow-sm backdrop-blur-sm transition-all hover:border-slate-300 hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-primary/30">
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </DialogPrimitive.Close>
      )}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
));
DialogContent.displayName = 'DialogContent';

export const DialogHeader = ({ className, ...props }) => (
  <div className={cn('relative flex shrink-0 flex-col space-y-1.5 border-b border-slate-100 bg-slate-50/50 px-6 py-5 text-left pr-14 sm:px-8', className)} {...props} />
);

export const DialogTitle = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Title ref={ref} className={cn('text-lg font-bold tracking-tight text-slate-900 sm:text-xl', className)} {...props} />
));
DialogTitle.displayName = 'DialogTitle';

export const DialogDescription = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Description ref={ref} className={cn('text-sm leading-relaxed text-slate-500', className)} {...props} />
));
DialogDescription.displayName = 'DialogDescription';

export const DialogBody = ({ className, ...props }) => (
  <div className={cn('min-h-0 min-w-0 flex-1 space-y-6 overflow-x-hidden overflow-y-auto overscroll-contain px-6 py-6 tm-scrollbar sm:px-8', className)} {...props} />
);

export const DialogFooter = ({ className, ...props }) => (
  <div className={cn('flex shrink-0 flex-col-reverse gap-2.5 border-t border-slate-100 bg-slate-50/70 px-6 py-4 rounded-b-2xl sm:flex-row sm:items-center sm:justify-end sm:gap-3 sm:px-8', className)} {...props} />
);
